import { Box } from "@mui/material"
import { type FC, useMemo } from "react"
import { useFormContext } from "react-hook-form"

import { GoodsReceiptDetailsSubtotals, GoodsReceiptPurchaseOrderPanel } from "../../../../components"
import type { IncomingPurchaseOrdersFormValues } from "../../schemas"
import { calculateIncomingPurchaseOrderFormTotals } from "../../utils"

import { IncomingPurchaseOrderLineForm } from "./IncomingPurchaseOrderLineForm"

import { type Order } from "@/graphql/codegen/graphql"

interface IncomingPurchaseOrderFormProps {
  purchaseOrder: Order
  purchaseOrderIndex: number
  isResettingRef?: React.MutableRefObject<boolean>
  canMaintain: boolean
  onRemove?: (purchaseOrderId: number) => void
}

export const IncomingPurchaseOrderForm: FC<IncomingPurchaseOrderFormProps> = ({
  purchaseOrder,
  purchaseOrderIndex,
  isResettingRef,
  canMaintain,
  onRemove,
}) => {
  const { watch } = useFormContext<IncomingPurchaseOrdersFormValues>()

  const formValues = watch()

  const totals = useMemo(() => {
    const lineFormValues = formValues.purchaseOrders[purchaseOrderIndex]?.lines ?? []
    return calculateIncomingPurchaseOrderFormTotals(lineFormValues)
  }, [formValues, purchaseOrderIndex])

  return (
    <GoodsReceiptPurchaseOrderPanel
      key={purchaseOrder.orderId}
      purchaseOrder={purchaseOrder}
      totals={totals}
      onRemove={onRemove}
    >
      <Box className='flex flex-col gap-y-6'>
        {purchaseOrder.orderLines?.map((purchaseOrderLine, purchaseOrderLineIndex) => (
          <IncomingPurchaseOrderLineForm
            key={purchaseOrderLine.orderLineId}
            purchaseOrderLine={purchaseOrderLine}
            purchaseOrderIndex={purchaseOrderIndex}
            purchaseOrderLineIndex={purchaseOrderLineIndex}
            isResettingRef={isResettingRef}
            canMaintain={canMaintain}
          />
        ))}
        <GoodsReceiptDetailsSubtotals label='Estimated Subtotal' totals={totals} />
      </Box>
    </GoodsReceiptPurchaseOrderPanel>
  )
}
